// MAJLIS-145 (UI-C35, UI-S3): the one way a day and time are printed in the rooms lists. My majlis prints
// "{day} · {time}" in the viewer's locale; Your rooms prints the same, except "Today · {time}" and "Yesterday · {time}"
// for those calendar days on this phone. `now` is always passed in (the app's injected wall clock), never read here.
import type { Translate, UiLang } from "./index";

const time = (lang: UiLang, at: number) => new Intl.DateTimeFormat(lang, { hour: "2-digit", minute: "2-digit" }).format(at);

/** My majlis's style: "Wed, Sep 30 · 08:23 PM" in the viewer's locale. */
export function dayAndTime(lang: UiLang, at: number): string {
  const day = new Intl.DateTimeFormat(lang, { weekday: "short", month: "short", day: "numeric" }).format(at);
  return `${day} · ${time(lang, at)}`;
}

/** The start of this phone's local calendar day holding `ms`. */
function dayStart(ms: number): number {
  const d = new Date(ms);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/** A Your rooms row's start: "Today · 08:17 PM", "Yesterday · 10:42 PM", else "Tue, Sep 29 · 10:42 PM". */
export function startedWhen(lang: UiLang, t: Translate, at: number, now: number): string {
  const today = dayStart(now);
  const day = dayStart(at);
  if (day === today) return t("startedToday", { t: time(lang, at) });
  const d = new Date(today);
  const yesterday = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1).getTime();
  if (day === yesterday) return t("startedYesterday", { t: time(lang, at) });
  return dayAndTime(lang, at);
}
